<div class="calendar-list">
    <div class="calendar-list-day">
        <span class="calendar-list-weekday">
            {{ viewDate | date :'EEE':'':locale}}
        </span>
        <span class="calendar-list-day-number">
            {{viewDate | date: 'dd'}}
        </span>
        <span class="calendar-list-number-events">
            <span *ngIf="!events || events.length === 0">
                Nenhum Evento
            </span>     
            <span *ngIf="events?.length > 0">
                {{events.length}} evento(s)
            </span>
        </span>
    </div>
    <div class="calendar-list-events" *ngIf="events?.length > 0">
        <div 
            class="cal-event"
            *ngFor="let event of events"
            [ngStyle]="{'background-color': event.color?.secondary, 'color': event.color?.primary, 'border-width': '2px', 'border-style': 'solid', 'border-color': event.color?.primary}"
            (click)="eventClicked.emit(event)">

            <div *ngIf="event.actions?.length > 0" class="dropdown dropdown-actions" (click)="dropdownEventActionsClick(dropdownEventActions, $event)" #dropdownEventActions>
                <button type="button" class="btn btn-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" tabindex="-1" [ngStyle]="{'color': event.color?.primary}">
                    <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu">
                    <a class="dropdown-item {{action.cssClass}}" *ngFor="let action of event.actions" (click)="actionClick(event, action, $event, dropdownEventActions)">
                        <span [innerHtml]="action.label"></span> {{action.a11yLabel}}
                    </a>
                </div>
            </div>
                        
            <div class="cal-event-body" [ngStyle]="{'color': event.color?.primary}">
                <ng-template
                    [ngTemplateOutlet]="eventTemplate || defaultEventTemplate"
                    [ngTemplateOutletContext]="{
                        event: event,
                        eventMeta: event.meta ? event.meta : null
                    }">
                </ng-template>	
            </div>
        </div>
    </div>
</div>

<ng-template
	#defaultEventTemplate
	let-event="event">
	<h6 class="cal-event-title" [ngStyle]="{'color': event.color?.primary}">
		{{event.title}}
	</h6>
</ng-template>